module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":"Widgets available for"},"ua":{"header":"Widgets available for"},"ru":{"header":"Widgets available for"}}')
  delete Component.options._Ctor
}
